import config from "../../config/config";

export const acceptedRegion = (region) => {
  if (region?.toLowerCase() in config) {
    return true;
  }

  return false;
}
